import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UnderwritingBorrowerIncome, UnderwritingIncomeDto } from 'api/UnderwritingApi';
import { BorrowerType } from 'enums/BorrowerType';

const initialState: UnderwritingIncomeDto = {
  borrower: {
    selectedIncomes: [],
    other: '',
    total: 0,
    incomes: {},
    w2Incomes: {},
  },
  coBorrower: {
    selectedIncomes: [],
    other: '',
    total: 0,
    incomes: {},
    w2Incomes: {},
  },
};

const income = createSlice({
  name: 'coBorrower',
  initialState,
  reducers: {
    setIncome: (
      state: UnderwritingIncomeDto,
      { payload }: PayloadAction<{ borrowerType: BorrowerType; borrowerIncome: UnderwritingBorrowerIncome }>,
    ) => {
      const { borrowerType, borrowerIncome } = payload;

      state[borrowerType] = {
        incomes: borrowerIncome.incomes,
        selectedIncomes: borrowerIncome.selectedIncomes,
        total: borrowerIncome.total,
        other: borrowerIncome.other,
        w2Incomes: borrowerIncome.w2Incomes,
      };
    },

    clearIncome: () => initialState,
  },
});

export const { setIncome, clearIncome } = income.actions;

export default income.reducer;
